import {EXPENSE_LIST, SHIPMENT_LIST} from "../Config/BillarApiUrl";
import {FormMixin} from "../../core/mixins/form/FormMixin";
import {DeleteMixins, ModalMixins} from "./billar/DeleteMixins";
import * as actions from '../Config/ApiUrl';
import {numberWithCurrencySymbol} from "../Helpers/Helpers";
import {urlGenerator} from "../Helpers/AxiosHelper"
import {Purpose} from "./FilterMixin";
import {statusType} from "./FilterMixin";

export default {
	mixins: [FormMixin, Purpose, DeleteMixins, ModalMixins, statusType],
	data() {
		return {
			tableId: 'expense-table',
			rowData: {},
			expenseSummery: {},
			preloader: false,
			isPurposeModalActive: false,
			numberWithCurrencySymbol,
			options: {
				url: SHIPMENT_LIST,
				name: this.$t('shipments'),
				filters: [
					{
						'title': this.$t('created'),
						'type': 'range-picker',
						'key': 'date',
						'option': ['today', 'thisMonth', 'last7Days', 'nextYear']
					},
					{
						'title': this.$t('eta'),
						'type': 'range-picker',
						'key': 'eta',
						'option': ['today', 'thisMonth', 'last7Days', 'nextYear']
					},
					{
						title: this.$t("status"),
						type: "checkbox",
						key: "status",
						option: [],
						permission: this.$can('show_all_data') ? true : false
					},
					// {
					// 	title: this.$t('purpose'),
					// 	type: 'drop-down-filter',
					// 	key: 'expense_purpose',
					// 	option: [],
					// }
				],
				columns: [
					{
						title: this.$t('bill_of_loading'),
						type: 'text',
						key: 'bill_of_loading',
					},
					{
						title: this.$t('port_type'),
						type: 'object',
						key: 'get_port_type',
						modifier: (get_port_type) => get_port_type ? get_port_type.name : '-'
					},
					{
						title: this.$t('port'),
						type: 'text',
						key: 'port',
					},
					{
						title: this.$t('eta'),
						type: 'text',
						key: 'eta',
					},
					{
						title: this.$t('shipping_line'),
						type: 'text',
						key: 'shipping_line',
					},
					{
						title: this.$t('consignee'),
						type: 'text',
						key: 'consignee',
					},
					{
						title: this.$t('description'),
						type: 'text',
						key: 'description',
					},
					{
						title: this.$t('quantity'),
						type: 'text',
						key: 'quantity',
					},
					{
						title: this.$t('declaration_number'),
						type: 'text',
						key: 'declaration_number',
					},
					{
						title: this.$t('status'),
						type: 'object',
						key: 'status',
						modifier: (status) => status? status.name : '-',
					},
					{
						title: this.$t('actions'),
						type: 'action'
					}
				],
				actions: [

					{
						title: this.$t('edit'),
						type: 'edit',
						modifier: () => this.$can("update_invoices"),
					},
					{
						title: this.$t('delete'),
						type: 'delete',
						modifier: () => this.$can("delete_invoices"),
					}
				],
				rowLimit: 10,
				orderBy: 'desc',
				responsive: true,
				showHeader: true,
				showFilter: true,
				showSearch: true,
				showAction: true,
				tableShadow: true,
				actionType: 'dropdown',
				datatableWrapper: true,
				paginationType: 'pagination'
			},
		}
	},
	methods: {
		getListAction(rowData, actionObj) {
			if (actionObj.type === 'edit') {
				this.selectUrl = `shipments/show/${rowData.id}`;
				this.isModalActive = true;
			} else if (actionObj.type === 'delete') {
				this.selectUrl = `shipments/delete/${rowData.id}`;
				this.confirmationModalActive = true;
			}
		},
	}
}
